import { Button, Dialog, DialogContent, Typography, Stack } from '@mui/material';
import { FC } from 'react';
import useLocales from '@hooks/useLocales';
import DialogTitle from '../../dialog-title';
import { styles } from './styles';

type Props = {
  open: boolean;
  onCancel: (event: React.MouseEvent<HTMLElement>) => void;
  onClickLeaveAnyway: (event: React.MouseEvent<HTMLElement>) => void;
  title: string;
  description: string;
  button_text: string;
};

const LeavePageDialog: FC<Props> = ({
  open,
  onCancel,
  onClickLeaveAnyway,
  title,
  description,
  button_text,
}) => {
  const { t } = useLocales();

  return (
    <Dialog onClose={onCancel} open={open}>
      <DialogTitle onClose={onCancel} title={title} />
      <DialogContent dividers sx={styles.dialogContent}>
        <Typography variant="body1" mb="48px">
          {description}
        </Typography>
        <Stack direction="row" spacing="12px">
          <Button
            variant="outlined"
            size="medium"
            color="inherit"
            sx={styles.button}
            onClick={onCancel}
          >
            {t('dashboard.search.results.leave_page.cancel')}
          </Button>
          <Button
            variant="contained"
            size="medium"
            color="primary"
            sx={styles.button}
            onClick={onClickLeaveAnyway}
          >
            {button_text}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default LeavePageDialog;
